// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type InvitationCheck,
  InvitationCheckFromJSON,
  InvitationCheckToJSON,
} from "../models/InvitationCheck";
import {
  type InvitationCreate,
  InvitationCreateFromJSON,
  InvitationCreateToJSON,
} from "../models/InvitationCreate";
import {
  type InvitationRead,
  InvitationReadFromJSON,
  InvitationReadToJSON,
} from "../models/InvitationRead";
import {
  type InvitationStatus,
  InvitationStatusFromJSON,
  InvitationStatusToJSON,
} from "../models/InvitationStatus";
import {
  type PageInvitationRead,
  PageInvitationReadFromJSON,
  PageInvitationReadToJSON,
} from "../models/PageInvitationRead";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface InvitationAcceptRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  invitationId: string;
}

export interface InvitationCheckRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  invitationId: string;
}

export interface InvitationCreateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  invitationCreate: InvitationCreate;
}

export interface InvitationListRequest {
  /**
   *
   */
  tenantId: string;
  /**
   * Page size limit
   */
  limit?: number;
  /**
   * Page offset
   */
  offset?: number;
  /**
   * Field to order by
   */
  orderBy?: InvitationListOrderByEnum;
  /**
   * Whether ordering is case-sensitive
   */
  orderByCaseSensitive?: boolean;
  /**
   *
   */
  status?: Array<InvitationStatus> | null;
  /**
   * Deprecated, use status filter instead.
   * @deprecated
   */
  isExpired?: boolean | null;
  /**
   *
   */
  project?: string | null;
  /**
   * Filter invites without a project ID
   */
  tenantOnly?: boolean;
}

export interface InvitationSendEmailRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  invitationId: string;
}

export interface RevokeInvitationRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  invitationId: string;
}

/**
 *
 */
export class InvitationsApi extends runtime.BaseAPI {
  /**
   * Creates request options for invitationAccept without sending the request
   */
  async invitationAcceptRequestOpts(
    requestParameters: InvitationAcceptRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling invitationAccept().'
      );
    }

    if (requestParameters["invitationId"] == null) {
      throw new runtime.RequiredError(
        "invitationId",
        'Required parameter "invitationId" was null or undefined when calling invitationAccept().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_retrieve",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/invitations/{invitation_id}/accept`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{invitation_id}",
      encodeURIComponent(String(requestParameters["invitationId"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Accept an invitation and assign the role.
   * Accept an invitation
   */
  async invitationAcceptRaw(
    requestParameters: InvitationAcceptRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<InvitationRead>> {
    const requestOptions = await this.invitationAcceptRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => InvitationReadFromJSON(jsonValue));
  }

  /**
   * Accept an invitation and assign the role.
   * Accept an invitation
   */
  async invitationAccept(
    requestParameters: InvitationAcceptRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<InvitationRead> {
    const response = await this.invitationAcceptRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for invitationCheck without sending the request
   */
  async invitationCheckRequestOpts(
    requestParameters: InvitationCheckRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling invitationCheck().'
      );
    }

    if (requestParameters["invitationId"] == null) {
      throw new runtime.RequiredError(
        "invitationId",
        'Required parameter "invitationId" was null or undefined when calling invitationCheck().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/tenants/{tenant_id}/invitations/{invitation_id}/check`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{invitation_id}",
      encodeURIComponent(String(requestParameters["invitationId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Check if an invitation is valid and if yes, retrieve it.
   * Check if an invitation is valid
   */
  async invitationCheckRaw(
    requestParameters: InvitationCheckRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<InvitationCheck>> {
    const requestOptions = await this.invitationCheckRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => InvitationCheckFromJSON(jsonValue));
  }

  /**
   * Check if an invitation is valid and if yes, retrieve it.
   * Check if an invitation is valid
   */
  async invitationCheck(
    requestParameters: InvitationCheckRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<InvitationCheck> {
    const response = await this.invitationCheckRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for invitationCreate without sending the request
   */
  async invitationCreateRequestOpts(
    requestParameters: InvitationCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling invitationCreate().'
      );
    }

    if (requestParameters["invitationCreate"] == null) {
      throw new runtime.RequiredError(
        "invitationCreate",
        'Required parameter "invitationCreate" was null or undefined when calling invitationCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_manage",
        "tenant_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/invitations`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: InvitationCreateToJSON(requestParameters["invitationCreate"]),
    };
  }

  /**
   * Provide relevant details for the to be created invitation.
   * Create new invitation
   */
  async invitationCreateRaw(
    requestParameters: InvitationCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<InvitationRead>> {
    const requestOptions = await this.invitationCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => InvitationReadFromJSON(jsonValue));
  }

  /**
   * Provide relevant details for the to be created invitation.
   * Create new invitation
   */
  async invitationCreate(
    requestParameters: InvitationCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<InvitationRead> {
    const response = await this.invitationCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for invitationList without sending the request
   */
  async invitationListRequestOpts(
    requestParameters: InvitationListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling invitationList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["orderBy"] != null) {
      queryParameters["order_by"] = requestParameters["orderBy"];
    }

    if (requestParameters["orderByCaseSensitive"] != null) {
      queryParameters["order_by_case_sensitive"] = requestParameters["orderByCaseSensitive"];
    }

    if (requestParameters["status"] != null) {
      queryParameters["status"] = requestParameters["status"];
    }

    if (requestParameters["isExpired"] != null) {
      queryParameters["is_expired"] = requestParameters["isExpired"];
    }

    if (requestParameters["project"] != null) {
      queryParameters["project"] = requestParameters["project"];
    }

    if (requestParameters["tenantOnly"] != null) {
      queryParameters["tenant_only"] = requestParameters["tenantOnly"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_manage",
        "tenant_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/invitations`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return a list of invitations.
   * List invitations
   */
  async invitationListRaw(
    requestParameters: InvitationListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PageInvitationRead>> {
    const requestOptions = await this.invitationListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PageInvitationReadFromJSON(jsonValue)
    );
  }

  /**
   * Return a list of invitations.
   * List invitations
   */
  async invitationList(
    requestParameters: InvitationListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PageInvitationRead> {
    const response = await this.invitationListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for invitationSendEmail without sending the request
   */
  async invitationSendEmailRequestOpts(
    requestParameters: InvitationSendEmailRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling invitationSendEmail().'
      );
    }

    if (requestParameters["invitationId"] == null) {
      throw new runtime.RequiredError(
        "invitationId",
        'Required parameter "invitationId" was null or undefined when calling invitationSendEmail().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_manage",
        "tenant_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/invitations/{invitation_id}/send-email`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{invitation_id}",
      encodeURIComponent(String(requestParameters["invitationId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Send email to invited user with accept url.
   * Send an invitation email
   */
  async invitationSendEmailRaw(
    requestParameters: InvitationSendEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<InvitationRead>> {
    const requestOptions = await this.invitationSendEmailRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => InvitationReadFromJSON(jsonValue));
  }

  /**
   * Send email to invited user with accept url.
   * Send an invitation email
   */
  async invitationSendEmail(
    requestParameters: InvitationSendEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<InvitationRead> {
    const response = await this.invitationSendEmailRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for revokeInvitation without sending the request
   */
  async revokeInvitationRequestOpts(
    requestParameters: RevokeInvitationRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling revokeInvitation().'
      );
    }

    if (requestParameters["invitationId"] == null) {
      throw new runtime.RequiredError(
        "invitationId",
        'Required parameter "invitationId" was null or undefined when calling revokeInvitation().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_manage",
        "tenant_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/invitations/{invitation_id}/revoke`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{invitation_id}",
      encodeURIComponent(String(requestParameters["invitationId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Revoke an invitation.
   * Revoke an invitation.
   */
  async revokeInvitationRaw(
    requestParameters: RevokeInvitationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<InvitationRead>> {
    const requestOptions = await this.revokeInvitationRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => InvitationReadFromJSON(jsonValue));
  }

  /**
   * Revoke an invitation.
   * Revoke an invitation.
   */
  async revokeInvitation(
    requestParameters: RevokeInvitationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<InvitationRead> {
    const response = await this.revokeInvitationRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const InvitationListOrderByEnum = {
  Role: "role",
  Role2: "-role",
  Status: "status",
  Status2: "-status",
  CreatedAt: "created_at",
  CreatedAt2: "-created_at",
  UpdatedAt: "updated_at",
  UpdatedAt2: "-updated_at",
} as const;
export type InvitationListOrderByEnum =
  (typeof InvitationListOrderByEnum)[keyof typeof InvitationListOrderByEnum];
